import React from 'react'
import { useLanguageContext } from '../../contexts/LanguageContext'
import './Contact.css'
import SEO from '../seo/SEO'

const Contact: React.FC = () => {
  const { content } = useLanguageContext()
  
  return (
    <>
      <SEO
        title={content.contact.seo.title}
        description={content.contact.seo.description}
      />
      <section id="contact" className="contact-section">
        <div className="container">
          {/* Contact Information Only */}
          <div className="contact-info-row">
            <div className="contact-info-box">
              {/* LEFT COLUMN — Static Text */}
              <div className="info-left">
                <p className="section-subtitle">{content.contact.subtitle}</p>
                <h4 className="left-subtitle">{content.contact.title}</h4>
                <p className="left-text">{content.contact.description}</p>
              </div>

              {/* RIGHT COLUMN — Existing Dynamic Content */}
              <div className="info-right">
                <p className="section-subtitle">{content.contact.info}</p>

                <div className="info-item">
                  <strong>{content.contact.emailtitle}</strong>
                  <a href={`mailto:${content.contact.realemail}`}>
                    {content.contact.email}
                  </a>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>
    </>
  )
}

export default Contact
